import './styles.scoped.css'
import {PersonAddAltRounded, SelfImprovementRounded, DateRangeRounded, UploadFileRounded} from '@mui/icons-material'
import {Typography} from '@mui/material'
import {useMobile} from '../../../../hooks'
import {useNavigate} from 'react-router-dom'

export default () => {
    const {mobile} = useMobile()
    const navigate = useNavigate()

    return (
        <div className="container">
            <div className="card" onClick={() => navigate('/clients-management/client-form')}>
                <div className="icon-container">
                    <PersonAddAltRounded fontSize={mobile ? 'small' : 'large'} />
                </div>
                <Typography variant={mobile ? 'h10' : 'h8'} color="text.primary">
                    Add New Client
                </Typography>
            </div>
            <div className="card" onClick={() => navigate('/caregivers-management/caregiver-form')}>
                <div className="icon-container">
                    <SelfImprovementRounded fontSize={mobile ? 'small' : 'large'} />
                </div>
                <Typography variant={mobile ? 'h10' : 'h8'} color="text.primary">
                    Add New Caregiver
                </Typography>
            </div>
            <div className="card" onClick={() => navigate('/scheduling/schedule-form')}>
                <div className="icon-container">
                    <DateRangeRounded fontSize={mobile ? 'small' : 'large'} />
                </div>
                <Typography variant={mobile ? 'h10' : 'h8'} color="text.primary">
                    Create New Schedule
                </Typography>
            </div>
            <div className="card">
                <div className="icon-container">
                    <UploadFileRounded fontSize={mobile ? 'small' : 'large'} />
                </div>
                <Typography variant={mobile ? 'h10' : 'h8'} color="text.primary">
                    Upload Agreement
                </Typography>
            </div>
        </div>
    )
}
